import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { PurchaseReturnLine, PurchaseReturnLineCreate, PurchaseReturnLineFilter } from '../data/purchaseReturnLine';

export function createPurchaseReturnLineService(client: AxiosInstance) {
  return createCrudService<PurchaseReturnLine, PurchaseReturnLineCreate, PurchaseReturnLineFilter>(
    client,
    '/purchase/PurchaseReturnLine',
    'id',
  );
}

export type PurchaseReturnLineService = CrudService<PurchaseReturnLine, PurchaseReturnLineCreate, PurchaseReturnLineFilter>;
